export const ADDTOCART = "cart/addToCart";
export const DECREASE = "cart/decreaseQuantity";
export const DELETE = "cart/deleteProduct";
